import Drawer from "./index";
const WithDrawer =
  (WrappedComponent) =>
  ({
    open,
    anchor,
    variant,
    BackdropProps,
    drawerClasses,
    customModalClasses,
    customDrawerPaperClasses,
    applyDrawerShadow,
    ModalProps={},
    ...otherProps
  }) =>
    (
      <Drawer
        open={open}
        anchor={anchor}
        variant={variant}
        BackdropProps={BackdropProps}
        customModalClasses={customModalClasses}
        customDrawerPaperClasses={customDrawerPaperClasses}
        applyDrawerShadow={applyDrawerShadow}
        ModalProps={ModalProps}
        drawerClasses={drawerClasses}>
        <WrappedComponent {...otherProps} />
      </Drawer>
    );

export default WithDrawer;
